export default __webpack_public_path__ + "static/media/a038-2.ee0f9bba.svg";